// NotificationDispatcherPage.jsx
import React from 'react';
import NotificationDispatcher from '../../components/dev/NotificationDispatcher';

const NotificationDispatcherPage = () => {
  return <NotificationDispatcher />;
};

export default NotificationDispatcherPage;
